module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lepus/lep_ir-57b05bd8567afd1e8a49363bf96008c6.jpg";